/**
 * Approved by product owner 2026-08-17.
 *
 * Order-level attribution. GA4 is unreachable here (web-pixels sandbox, no
 * window.gtag on the live site — verified), so measurement is instead the
 * cart attribute `_rec_adds` (comma-separated product IDs), read later by
 * the dashboard off the order. ONLY mutation this script performs: POSTing
 * that one attribute via /cart/update.js — never line items, never
 * quantities. Underscore prefix = Shopify convention: hidden from customer
 * checkout/order pages, still visible to staff in admin > Additional
 * details. Approved by product owner 2026-08-17, after rejecting line-item
 * properties (those split cart lines per product/property combination).
 * Both add paths in <smart-cart-recs> route through pending→confirm, since
 * neither confirms success at click: instant (.quick-add__button--add) and
 * popup multi-variant (.quick-add__button--choose, opens #quick-add-dialog,
 * no variant chosen yet). Both just set `pending = {productId, expiresAt}`
 * at click; only a matching 'cart:update' stamps the attribute — a click
 * alone writes nothing.
 *
 * Live-verified signal: assets/events.js's CartAddEvent/CartUpdateEvent both
 * dispatch 'cart:update'. detail.data.productId is the real add's product ID
 * (string); detail.data.source is 'product-form-component' for adds vs.
 * 'cart-items-component' for quantity edits elsewhere. Match productId when
 * present, else require the product-form source — only one popup open at a
 * time. No imports: matches raw 'cart:update'/'dialog:close' strings rather
 * than ThemeEvents classes (plain script, not a module). data-title/
 * data-price on <product-card> (smart-cart-recs-card.liquid) are no longer
 * consumed here — only data-product-id is read.
 */
(function () {
  // The cart page and the cart drawer can both include this file on one page;
  // the listeners are document-level, so only the first include may register.
  if (window.__smartCartRecsAttribution) return;
  window.__smartCartRecsAttribution = true;
  var PENDING_TTL_MS = 3 * 60 * 1000;
  var MAX_IDS = 20;
  var pending = null; // { productId, expiresAt }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('smart-cart-recs')) return;
    var card = event.target.closest('product-card');
    if (!card) return;
    if (!event.target.closest('.quick-add__button--add') && !event.target.closest('.quick-add__button--choose')) return;
    pending = { productId: card.getAttribute('data-product-id'), expiresAt: Date.now() + PENDING_TTL_MS };
  });

  document.addEventListener('cart:update', function (event) {
    if (!pending) return;
    if (Date.now() > pending.expiresAt) { pending = null; return; }
    var data = (event.detail && event.detail.data) || {};
    if (data.didError) { pending = null; return; }
    if (data.productId != null) {
      if (String(data.productId) !== String(pending.productId)) return;
    } else if (data.source !== 'product-form-component') {
      return; // Not a genuine add signal (e.g. a quantity edit elsewhere in the cart).
    }
    var productId = String(pending.productId);
    pending = null; // Never fire twice for one add.
    fetch('/cart.js').then(function (res) { return res.json(); }).then(function (cart) {
      var raw = (cart.attributes && cart.attributes['_rec_adds']) || '';
      var ids = raw ? raw.split(',').filter(Boolean) : [];
      if (ids.indexOf(productId) !== -1) return; // Already stamped, skip the POST.
      ids.push(productId);
      if (ids.length > MAX_IDS) ids = ids.slice(ids.length - MAX_IDS); // Cap, drop oldest.
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _rec_adds: ids.join(',') } }) });
    }).catch(function () {}); // Attribution is best-effort; a network failure must not surface errors.
  });

  // Best-effort cleanup if the popup is closed without adding. #quick-add-dialog
  // dispatches 'dialog:close' on itself, not document (DialogCloseEvent has no
  // bubbles:true) — listen directly on the element instead of importing the class.
  // Verified live (temporary console listeners, real popup add, cart page):
  // 'cart:update' fires first, then 'dialog:close' ~150ms later — so on a
  // successful add, pending is already cleared by the 'cart:update' handler
  // above before this fires. This handler only ever catches the close-without-
  // adding case (Esc / outside click / close button), by design.
  var quickAddDialog = document.getElementById('quick-add-dialog');
  if (quickAddDialog) {
    quickAddDialog.addEventListener('dialog:close', function () { pending = null; });
  }
})();
